export const environment = {
  production: true,
  //authApiBase: 'http://localhost:8082/api/auth',
  //dataApiBase: 'http://localhost:8083/api/opportunities',
  //authApiBase: 'http://74.234.38.91/api/auth',
  //dataApiBase: 'http://74.234.38.91/api/data'
  authApiBase: '/api/auth',
  dataApiBase: '/api/data',
  customerApiBase: '/api/customer',
};
